import React from "react";
import { Container, Row, Col, Stack } from "react-bootstrap";
import { FaTwitter, FaInstagram, FaFacebookF, FaLinkedinIn, FaYoutube, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import "./Footer.css";

function Footer() {
  const services = [
    "Solar Permit Design",
    "Solar Preliminary Design",
    "Solar Sales Proposal",
    "PTO and Permitting",
    "Engineering Stamp"
  ];

  return (
    <footer className="footer">
      <Container>
        <Row className="footer-row">

          <Col md={5} className="mb-4 mb-md-0">
            <div className="footer-logo-box">
              <img src="/images/footer-logo.png" alt="One Place Solar Logo" className="ops-footer-logo" />
               <p className="footer-text">
              Your Premier Destination for Solar Plans, Engineering Reviews, PTO, and Permits, 
              Crafted by Certified Design and Engineering Professionals.
            </p>
            </div>
          </Col>

          {/* Services */}
          <Col md={4} className="mb-4 mb-md-0">
            <h5 className="footer-heading">Services</h5>
            <ul className="footer-links-list">
              {services.map((service, index) => (
              <li key={index} className="footer-link">
              <a href={`#${service.replace(/\s+/g, '-').toLowerCase()}`} style={{ textDecoration: 'none', color: 'inherit' }}>
               {service}
              </a>
              </li>
               ))}
            </ul>
          </Col>

          <Col md={3}>
            <h5 className="footer-heading">Contact Us</h5>
            <Stack gap={2}>
              <ContactItem icon={<FaPhoneAlt />} text="US: +1 (209) 888 0133" />
              <ContactItem icon={<FaPhoneAlt />} text="UK: +44 746 359 0518" />
              <ContactItem icon={<FaPhoneAlt />} text="CA: +1 (647) 367 2775" />
              <ContactItem icon={<FaPhoneAlt />} text="AUS: +61 489 270 294" />
              <ContactItem 
                icon={<FaEnvelope />} 
                text={
                  <a href="info@oneplacesolar.com" className="footer-email">
                    info@oneplacesolar.com
                  </a>
                } 
              />
            </Stack>

            <div className="footer-social">
              <a href="https://x.com/OnePlaceSolar" target="_blank" rel="noreferrer"><FaTwitter title="Twitter" /></a>
              <a href="https://www.instagram.com/oneplacesolar" target="_blank" rel="noreferrer"><FaInstagram title="Instagram" /></a>
              <a href="https://www.facebook.com/profile.php?id=100085536570207" target="_blank" rel="noreferrer"><FaFacebookF title="Facebook" /></a>
              <a href="https://www.linkedin.com/company/one-place-solar/" target="_blank" rel="noreferrer"><FaLinkedinIn title="LinkedIn" /></a>
              <a href="https://www.youtube.com/@oneplacesolar" target="_blank" rel="noreferrer"><FaYoutube title="YouTube" /></a>
            </div>
          </Col>
        </Row>

        <hr className="footer-divider" />
        <div className="footer-bottom">
          © {new Date().getFullYear()} One Place Solar. All Rights Reserved.
        </div>
      </Container>
    </footer>
  );
}

function ContactItem({ icon, text }) {
  return (
    <div className="contact-item">
      <span className="contact-icon">{icon}</span>
      <span className="contact-text">{text}</span>
    </div>
  );
}

export default Footer;